import adaptUi from './adapt.ui';
import adaptSanitize from './adapt.sanitize';
import adaptModal, { initModals } from "./adapt.modal";
import { picklist, taglist, initPicklists } from "./adapt.picklist";

$(function(){
    let isIframe = inIframe();
    if(!isIframe) // <====== This should not cause any issue, but if in doubt just remove it (used to remove a JS error)
    {
        adapt.ui.attach_event_handlers();
        $.datepicker.setDefaults({
            yearRange: "2013:"+new Date().getFullYear()
        });

        $('[data-toggle=\"tooltip\"]').tooltip();

        // Is browser IE?
        if(navigator.userAgent.match(/Trident/g) || navigator.userAgent.match(/MSIE/g)) {
            $(".view.notifications").prepend("<div class='alert alert-danger alert-dismissible transparent-notification fixed-notification browser-not-supported'>" +
                "<div class='row'><div class='col-lg-push-1 col-lg-10 col-md-push-1 col-md-10 col-sm-11 col-xs-11'>" +
                "The browser you are using is unfortunately not supported on this website, please use " +
                "<a href='https://www.google.com/chrome/' target='_blank'>Google Chrome</a> to browse our current jobs " +
                "and submit your application. We apologise for any inconvenience.</div><div class='col-lg-1 col-md-1 col-sm-1 col-xs-1'>" +
                "<button type='button' class='close' data-dismiss='alert' aria-label='Close'>" +
                "<span aria-hidden='true'>&times;</span></button></div></div></div>");
        }
    }
    initModals();
    initPicklists();
});

function inIframe () {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}

window.adapt = {
    version: '1.1.143',
    ajax: function(url, container, callback){
        $(container).load(url, callback);
    },
    find_closest: function(start_point, target){
        var $start = $(start_point);

        while($start && $start.length && !$start.find(target).length){
            $start = $start.parent();
        }

        return $start.find(target);
    },
    ui: adaptUi,
    sanitize: adaptSanitize,
    modal: adaptModal,
    picklist,
    taglist
};
